<template>
    <div style="display:flex;">
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC no_print eldialogWidth" :modal="false" :title="'销售单('+form_params.order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="客户名称：" prop="customer_id">
                            <!-- <el-select v-model="form_params.customer_id" :disabled="true" filterable>
                                <el-option v-for="list in selectMap.customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.customer_name" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="销售人：" prop="salesman_id">
                            <!-- <el-select v-model="form_params.salesman_id" :disabled="true">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.salesman_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="付款方式：" prop="payment_type_id">
                            <!-- <el-select v-model="form_params.payment_type_id" :disabled="true">
                                <el-option v-for="list in selectMap.paymentType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.payment_type_name" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="预计收汇：" prop="predict_time">
                            <el-date-picker v-model="form_params.predict_time" :readonly="true" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="销售日期：" prop="sales_time">
                            <el-date-picker v-model="form_params.sales_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label="发货日期：" prop="delivery_time">
                            <el-date-picker v-model="form_params.delivery_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elFormBoxBtnList elDialogElFormBoxCheckbox">
                        <el-form-item  label="REC：">
                            <el-checkbox v-model="form_params.rec"></el-checkbox>
                            <el-input v-model="form_params.tax_rate" readonly v-if="form_params.rec" placeholder="税率%：" class="elDialogElFormBoxCheckboxREC checkbox"></el-input>
                        </el-form-item>
                        <el-form-item  label="锁货等级：" prop="order_lock_level_id" v-if="enableConfig.indexOf('LOCK_LEVEL')!=-1">
                            <!-- <el-select v-model="form_params.order_lock_level_id" disabled @visible-change="getSelectList('lockLevel')">
                                <el-option v-for="list in selectMap.lockLevel" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select> -->
                            <el-input v-model="form_params.order_lock_level_name" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elDialogElFormBoxCheckbox">      
                        <!-- <el-form-item label="税率%：" v-if="form_params.rec">
                            <el-input v-model="form_params.tax_rate"></el-input>
                        </el-form-item> -->
                        <el-form-item class="receivableRelationBox">
                            <div class="receivableRelation" @click="dialogVisibleRelation=!dialogVisibleRelation">关联应收</div>
                            <div class="recrivableNumber">￥{{form_params.traffic_amount}}</div>
                            <!-- <el-checkbox v-model="form_params.is_show_traffic"></el-checkbox>
                            <el-input v-model="form_params.traffic_amount" readonly v-if="form_params.is_show_traffic" placeholder="运费：" class="checkbox"></el-input> -->
                        </el-form-item>
                        <el-form-item  label="折扣：">
                            <el-checkbox v-model="form_params.is_discount_rate"></el-checkbox>
                            <el-input v-model="form_params.discount_rate" v-if="form_params.is_discount_rate" readonly @input="calculationTableTotal" placeholder="折扣：" class="checkbox"></el-input>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                    :sortable="false"
                                                    :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                    align="left"
                                                    show-overflow-tooltip
                                                >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'files' && form_params.id">
                                                <div @click.stop="relativeFileOpen(scope.row.files)">
                                                    <img src="/icon/associatedfiles.png" style="width:23px;height:23px;cursor:pointer;display:block;margin:auto;"/>
                                                </div>
                                            </div>
                                            <div v-else-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;listType=scope.$index;dialogVisibleWidth=true;widthSaleInventoryId=scope.row.inventory_id;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                    <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应收</div>
                        <div class="dialogTotalC" v-if="tableTotal.sales_amount&&tableTotal.sales_amount!=0.00">销售金额:{{tableTotal.sales_amount}}</div>
                        <div class="dialogTotalC" v-if="tableTotal.discount_amount&&tableTotal.discount_amount!=0.00">折扣金额:{{tableTotal.discount_amount}}</div>
                        <div class="dialogTotalC" v-if="tableTotal.tax_amount&&tableTotal.tax_amount!=0.00">税金:{{tableTotal.tax_amount}}</div>
                        <div class="dialogTotalC" v-if="tableTotal.traffic_amount&&tableTotal.traffic_amount!=0.00">关联费用:{{tableTotal.traffic_amount}}</div>
                        <div class="dialogTotalC" v-if="tableTotal.other_amount&&tableTotal.other_amount!=0.00">其它费用:{{tableTotal.other_amount}}</div>
                        <div class="dialogTotalC" v-if="tableTotal.reduce_amount&&tableTotal.reduce_amount!=0.00">优惠:{{tableTotal.reduce_amount}}</div>
                        <div class="dialogTotalC" v-if="tableTotal.receivable_amount&&tableTotal.receivable_amount!=0.00">应收金额:{{tableTotal.receivable_amount}}</div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                    <div class="editPayBox clearfix">
                        <el-form class="" :model="form_params" ref="saleorderB">
                            <div class="editPay">
                                <el-form-item  label="收款账户：" prop="account_id">
                                    <el-select v-model="form_params.account_id" :disabled="true">
                                        <el-option v-for="list in selectMap.account" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="editName">账号：{{form_params.bank_no}}</div>
                                <div class="editName">户名：{{form_params.account_name}}</div>
                                <div class="editName">开户行：{{form_params.bank_name}}</div>
                            </div>
                            <div class="editPay bottom_flex">
                                <!-- <el-form-item  label="首次付款：" prop="first_amount" style="margin-right:10px;">
                                    <el-input type="text" v-model="form_params.first_amount" :readonly="true"></el-input>
                                </el-form-item> -->
                                <div class="piaoMess clearfix" v-if="form_params.rec">
                                    <div class="piaoMessC">
                                        名称：{{bill.invoice_name}}<br/>
                                        开户行：{{bill.invoice_bank_name}}<br/>
                                        税号：{{bill.invoice_no}}
                                    </div>
                                    <div class="piaoMessC">
                                        账号：{{bill.invoice_bank_no}}<br/>
                                        地址：{{bill.invoice_addr}}<br/>
                                        电话：{{bill.invoice_phone}}
                                    </div>
                                </div>
                                <div class="clearfix">
                                    <el-form-item  label="首次付款：" prop="first_amount" style="margin-right:103px;float:left">
                                        <el-input type="text" v-model="form_params.first_amount" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="优惠：" prop="reduce_amount" style="float:left;">
                                        <el-input type="text" v-model="form_params.reduce_amount" readonly></el-input>
                                    </el-form-item>
                                </div>
                                <!-- <el-form-item  label="优惠：" prop="reduce_amount">
                                    <el-input type="text" v-model="form_params.reduce_amount" :readonly="true"></el-input>
                                </el-form-item> -->
                            </div>
                        </el-form>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                            </div>
                        </div>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print(8)">合同打印</el-button>
                        <el-button class="funcPublicBtn" @click="print(0)">打印</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!-- 关联应收费用 START -->
        <fee-relation-sale :dialogVisibleRelation="dialogVisibleRelation" :relatedremark="form_params.related_remark" :data="form_params.relate_list" :isEdit="false" @closeDialog="()=>{this.dialogVisibleRelation = false;}"></fee-relation-sale>
        <!-- 关联应收费用 END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="true" scene="order.create.column" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :list="widthList" :perval="1" :dialogvisible="dialogVisibleWidth"  @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
    </div>
</template>
<style scoped lang="scss">
    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .bottom_flex{padding-right: 12px; padding-bottom: 8px;}
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
</style>
<script>
import bus from "../eventBus";
import feeRelationSale from './feeRelationSale.vue';
import relativeFile from './downloadRelativeFile.vue';
export default {
    props:['dialogVisiblesale',"id"],
    data(){
        return{
            companyName:localStorage.dw_erp_company_name,
            module:localStorage.dw_erp_power_code,
            enableConfig:localStorage.dw_erp_enable_config,
            boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
            boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
            categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
            categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
            dialogVisible:false,
            dialogVisibleRelation:false,
            filterDialogVisible:false,
            dialogVisibleWidth:false,
            widthList:[],
            listDetail:[
                {id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}
            ],
            form_params:{
                id:"",
                account_id:"",
                first_amount:"",
                reduce_amoun:"",
                tax_rate:"",
                sales_time:new Date(),
                delivery_time:new Date(),
                predict_time:new Date(),
                salesman_id:localStorage.dw_erp_user_id?parseInt(localStorage.dw_erp_user_id):"",
                customer_id:"",
                payment_type_id:"",
                remark:"",
                is_request_review:"",
                bank_no:"",
                account_name:"",
                bank_name:"",
                inventory_list:[],
                isEdit:localStorage.dw_erp_power_code.indexOf(",sell-order-edit,")!=-1?true:false,
                order_sn:"",
                rec:0,
                relate_list:[],
                related_remark:""
            },
            totalObj:{},
            tableTotal:{
                  sales_amount:0.00,
                  discount_amount:0.00,
                  tax_amount:0.00,
                  traffic_amount:0.00,
                  other_amount:0.00,
                  reduce_amount:0.00,
                  receivable_amount:0.00
                },
            bill:{},
            printDetail:{
                fields:""
            },
            printTotal:[],
            newFee:[],
            billColumn:"",
            filter:"",
            filters: [],
            selectMap:{
                account:[]
            },
            downLoadFileDialog: false,
            downFilesList: [],
        }
    },
    created(){
        this.getSelectList('account')
        this.getBillColumn()
    },
    methods:{
        headDrog(newWidth, oldWidth, column) {
            this.filters.forEach((item) => {
                if (column.property == item.colKey) {
                    item.colWidth = newWidth;
                }
            });
            let obj = {};
            obj.width = parseInt(newWidth);
            obj.name = column.property;
            let emit = ("changeHeadWidth" + 'order.create.column').replace(/\./g, "");
            bus.$emit(emit, obj);
        },
        relativeFileOpen(files){
            this.downLoadFileDialog = true;
            this.downFilesList = files;
        },
        getSelectList(target){
            this.$getSelectList(target).then(res=>{
                this.selectMap[res.target]=res.list;
            })
        },
        filterConfirm(){
            this.getBillColumn();
            this.getDetail();
        },
        getBillMess(id){
            this.postFunc("/erp/customer.detail",{id:id},response=>{
                this.bill=response.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getBillColumn(){
            this.filters = [];
            this.postFunc("/erp/company.column.data",{scene:"order.create.column"},response=>{
                this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                this.filter = response.data.data.columns;
                this.filters = response.data.data.columns;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    sales_amount: 2,//金额
                    original_cube: 4,//码单立方
                    check_cube:4,//检尺立方
                    sales_cube:4,
                    min_amount:2,//最低额
                    // pledge_number:0,
                },total=>{
                });
            },
        selectAccount(val){
            this.selectMap.account.forEach(item=>{
                if(item.id==val){
                    this.form_params.bank_no=item.bank_no;
                    this.form_params.account_name=item.account_name;
                    this.form_params.bank_name=item.bank_name;
                }
            })
        },
        getDetail(){
            this.postFunc("/erp/order.order",{id:this.form_params.id},res=>{
                this.dialogVisible=true;
                let resD = res.data.data;
                if(resD.rec_type=='DIV'){
                    resD.rec_type = 2
                }else{
                    resD.rec_type = 1
                }
                this.form_params=res.data.data;
                this.listDetail=res.data.data.details;
                this.newFee = res.data.data.fee_list;
                this.listDetail.forEach((item,index)=>{
                    // this.listDetail[index].original_width_total=parseInt(item.original_width_total)
                    // this.listDetail[index].sales_price=parseFloat(item.sales_price).toFixed(2)
                    this.listDetail[index].sales_cube=this.keepLimit(item.sales_cube)
                    this.listDetail[index].original_cube=this.keepLimit(item.original_cube)
                    // this.listDetail[index].totalPrice=parseFloat(Number(item.sales_cube)*Number(item.sales_price)).toFixed(2)
                })
                this.totalObj=res.data.data.statistic;
                this.selectAccount(res.data.data.account_id)
                // this.list.forEach(item=>{
                //     if(item.id==obj.id){
                //         if(item.isPassReview){
                //             this.form_params.isPassReview=true;
                //         }
                //     }
                // })
                delete this.form_params.details;
                delete this.form_params.statistic;
                if(this.form_params.delivery_time!=0){
                    this.form_params.delivery_time = this.formatTime(this.form_params.delivery_time+"000")
                }
                if(this.form_params.predict_time!=0){
                    this.form_params.predict_time = this.formatTime(this.form_params.predict_time+"000")
                }
                if(this.form_params.sales_time!=0){
                    this.form_params.sales_time = this.formatTime(this.form_params.sales_time+"000")
                }
                this.form_params.rec=this.form_params.rec==1?true:false;
                this.form_params.is_show_traffic=this.form_params.is_show_traffic==1?true:false;
                this.form_params.is_discount_rate=this.form_params.is_discount_rate==1?true:false;
                this.getBillMess(this.form_params.customer_id)
                // this.refuse.id=this.form_params.id;
                // this.refuse.refuse_remark="";
                this.tableTotal.sales_amount = res.data.data.sales_amount;
                this.tableTotal.discount_amount = res.data.data.discount_amount;
                this.tableTotal.tax_amount = res.data.data.tax_amount;
                this.tableTotal.traffic_amount = res.data.data.traffic_amount;
                this.tableTotal.other_amount = res.data.data.other_amount;
                this.tableTotal.reduce_amount = res.data.data.reduce_amount;
                this.tableTotal.receivable_amount = res.data.data.receivable_amount;
                // this.calculationTableTotal()
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        print(type){
            let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + type;
            window.open(url);
        },

    },
    components:{
        feeRelationSale,
        relativeFile
    },
    watch:{
        id:function(val){
            this.form_params.id = val;
            if(val){
                this.getDetail()
            }
        },
        dialogVisiblesale:function(val){
            this.dialogVisible = val;
        },
        dialogVisible:function(val){
            if(!val){
                this.$emit("close")
            }
        }
    }
}
</script>